"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadSquareShape = void 0;
const SquareDrawer_1 = require("./SquareDrawer");
function loadSquareShape(tsParticles) {
    const drawer = new SquareDrawer_1.SquareDrawer();
    tsParticles.addShape("edge", drawer);
    tsParticles.addShape("square", drawer);
}
exports.loadSquareShape = loadSquareShape;
